<template>
  <line-chart :datasets="datasets" :options="dataoptions" :height="229" />
</template>

<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'DebtChart',
  props: {
    plan: {
      type: Object,
      required: true
    },
    minOnly: Boolean
  },
  components: {
    LineChart
  },
  mounted () {
  },
  computed: {
    datasets() {
      let minDataByDate = {}
      let minData = []
      let planDataByDate = {}
      let planData = []
      Object.keys(this.plan.data.debts).forEach(dkey => {
        const d = this.plan.data.debts[dkey]
        Object.keys(d.detail_original).forEach(k => {
          if(!minDataByDate[k]) minDataByDate[k] = 0
          minDataByDate[k] += parseFloat( d.detail_original[k].end_balance )
        })
        Object.keys(d.detail).forEach(k => {
          if(!planDataByDate[k]) planDataByDate[k] = 0
          planDataByDate[k] += parseFloat( d.detail[k].end_balance )
        })
      })
      Object.keys(this.plan.data.policies).forEach(pkey => {
        const p = this.plan.data.policies[pkey]
        Object.keys(p.detail).forEach(k => {
          if(k <= this.plan.data.payoff_date && k >= this.$moment(this.plan.start_date).format('YYYY-MM')) {
            if(!planDataByDate[k]) planDataByDate[k] = 0
            planDataByDate[k] += parseFloat( p.detail[k].loan_balance_end )
          }
        })
      })

      let planStart = this.$moment(this.plan.start_date)
      let mth       = planStart.format('YYYY-MM')
      while(mth < this.plan.data.payoff_date) {
        if(!minDataByDate[mth]) minDataByDate[mth] = 0
        if(!planDataByDate[mth]) planDataByDate[mth] = 0

        planStart   = planStart.add(1, 'month')
        mth         = planStart.format('YYYY-MM')
      }

      Object.keys(minDataByDate).forEach(dkey => {
        minData.push({
          x: this.$moment(dkey + '-01').toDate(),
          y: Math.round(minDataByDate[dkey])
        })
      })
      if(!this.minOnly) {
        Object.keys(planDataByDate).forEach(dkey => {
          planData.push({
            x: this.$moment(dkey + '-01').toDate(),
            y: Math.round(planDataByDate[dkey])
          })
        })
      }
      minData.sort((a,b) => {
        return a.x - b.x
      })
      planData.sort((a,b) => {
        return a.x - b.x
      })

      let data = [
        {
          label: 'No Plan',
          data: minData,
          backgroundColor: 'rgba(255,0,0,.1)',
          pointRadius: 1,
          borderWidth: .5
        }
      ]
      if(!this.minOnly) {
        data.push({
          label: 'WealthyIQ',
          data: planData,
          backgroundColor: 'rgba(64,174,117,.7)',
          pointRadius: 1,
          borderWidth: .5
        })
      }
      
      return data
    },
    dataoptions () {
      let ref = this
      //let endMonth = this.plan.min_freedom_months > this.plan.payoff_months ? this.plan_min_freedom_months : this.plan.payoff_months

      return {
        legend: {
          display: true
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              unit: 'year',
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            },
            //ticks: {
            //  min: ref.$moment(ref.plan.plan_start).toDate(),
            //  max: ref.$moment(ref.plan.plan_start).add(endMonth, 'months').toDate()
            //},
            distribution: 'linear'
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function(label) {
                return label/1000+'k';
              }
            }
          }]
        },
        tooltips: { 
          callbacks: { 
            label: function(tooltipItem) 
            {
              let cleaned = ('' + tooltipItem.value).replace(/[^0-9.]/g, '')
              if(cleaned == '') return '0.00'
              let numberAmount = Math.round( parseFloat(cleaned) )
              return '$' + new Intl.NumberFormat('en-US', {minimumFractionDigits: 0}).format(numberAmount.toFixed(2))
            },
            title: function(tooltipItems) {
              return ref.$moment(tooltipItems[0].xLabel, 'MMM D, YYYY, HH:mm:ss a').format('L')
            }
          }
        }
      }
    }
  }
}
</script>